(function() {
  function filterAnimalPicker(search) {
    if (!search) return;
    var root = search.closest ? search.closest('.bb-animal-picker') : null;
    if (!root) return;

    var term = (search.value || '').trim().toLowerCase();
    var empty = root.querySelector('[data-bb-animal-empty]');
    var labels = root.querySelectorAll('input[type="radio"] + label, input[type=radio] + label');
    var visibleCount = 0;

    labels.forEach(function(label) {
      var inputId = label.getAttribute('for');
      var input = inputId ? document.getElementById(inputId) : null;
      var labelText = (label.textContent || '').toLowerCase();
      var match = !term || labelText.indexOf(term) !== -1;

      label.style.display = match ? '' : 'none';
      label.hidden = !match;

      if (input) {
        input.style.display = match ? '' : 'none';
        input.hidden = !match;
        input.setAttribute('aria-hidden', match ? 'false' : 'true');
      }

      if (match && input && !input.disabled && !input.classList.contains('disabled')) {
        visibleCount += 1;
      }
    });

    if (empty) {
      empty.hidden = visibleCount !== 0;
      empty.style.display = visibleCount === 0 ? '' : 'none';
    }
  }

  function initAnimalPickers(scope) {
    var root = scope || document;
    var searches = root.querySelectorAll('[data-bb-animal-search]');
    searches.forEach(function(search) {
      if (search.dataset.bbAnimalSearchBound === 'true') return;
      search.dataset.bbAnimalSearchBound = 'true';
      search.addEventListener('input', function() { filterAnimalPicker(search); });
      search.addEventListener('search', function() { filterAnimalPicker(search); });
      filterAnimalPicker(search);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAnimalPickers(document); });
  } else {
    initAnimalPickers(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAnimalPickers(event.target || document);
  });

  document.addEventListener('input', function(event) {
    if (event.target && event.target.matches && event.target.matches('[data-bb-animal-search]')) {
      filterAnimalPicker(event.target);
    }
  });
})();
